import {
  createConfigProvisionings,
  updateConfigProvisionings,
  deleteConfigProvisionings
} from 'stores/slice/bogus/wired/configProvisionings';

import {
  getDefaultConfigProvisioningsByModel
} from 'stores/slice/bogus/wired/defaultConfigProvisionings';

const wiredConfig = {
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfig.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfig.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfig",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/ports.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/orgs/:orgId/sites/:siteId/settings/ports.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/ports",
    restful: true,
    method: "update",
    buildParams: (params) => ({ data: params.updates }),
    action: null,
    mockSelector: "wired",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "portTags",
  },
  "/orgs/:orgId/sites/:siteId/settings/tags/portTags.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "portTags",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  "/orgs/:orgId/sites/:siteId/settings/tags/portTags.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/tags/portTags",
    restful: true,
    method: "create",
    buildParams: null,
    action: null,
    mockSelector: null,
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.read": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.read": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "read",
    buildParams: null,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.create": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "create",
    buildParams: params => params,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.create": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "create",
    buildParams: params => params,
    action: createConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.update": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: updateConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.update": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "update",
    buildParams: params => params,
    action: updateConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/ents/:entId/orgs/:orgId/settings/wiredConfigProvisioning.delete": {
    protocol: "ws",
    resource: "/ents/:entId/orgs/:orgId/settings/wiredConfigProvisioning",
    restful: true,
    method: "delete",
    buildParams: params => params,
    action: deleteConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning.delete": {
    protocol: "ws",
    resource: "/orgs/:orgId/sites/:siteId/settings/wiredConfigProvisioning",
    restful: true,
    method: "delete",
    buildParams: params => params,
    action: deleteConfigProvisionings,
    mockSelector: "wiredConfigProvisionings",
  },
  "/system/wiredConfigProvisioning/defaultValues.read": {
    protocol: "ws",
    resource: "/system/wiredConfigProvisioning/defaultValues",
    restful: true,
    method: "read",
    buildParams: null,
    action: getDefaultConfigProvisioningsByModel,
    mockSelector: "defaultConfigProvisionings",
  },
  // Read all device models
  "/system/wiredConfigProvisioning/modelList.read": {
    protocol: "ws",
    resource: "/system/wiredConfigProvisioning/modelList",
    restful: true,
    method: "read",
    buildParams: null,
    action: null,
    mockSelector: "deviceModelList",
  },
};

export default wiredConfig;
